import { render, staticRenderFns } from "./ViewSidebar.vue?vue&type=template&id=08b6e976&scoped=true&"
import script from "./ViewSidebar.vue?vue&type=script&lang=js&"
export * from "./ViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ViewSidebar.vue?vue&type=style&index=0&id=08b6e976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b6e976",
  null
  
)

export default component.exports